<style lang="css">
</style>

<template lang="html">

<el-card>

    <table-template ref="table-template" actionUrl="carShow/user/findWithdrawCash.action" :queryParams="queryParams">
      <template slot="search">

        <el-row  style="margin-bottom: 20px;">
          <el-select v-model="queryParams.status" clearable @change="$refs['table-template'].search()" placeholder="审核状态">
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="审核通过" :value="2"></el-option>
            <el-option label="审核不通过" :value="3"></el-option>
            <el-option label="暂缓" :value="4"></el-option>
            <el-option label="异常" :value="5"></el-option>
          </el-select>

          <el-date-picker
            v-model="queryParams.rangeTime"
            type="datetimerange"
            range-separator="至"
            @change="onDateTimeRangeChange"
            start-placeholder="支付开始日期"
            end-placeholder="支付结束日期">
          </el-date-picker>

          <el-input v-model="queryParams.keyword" style="width:250px;" placeholder="请输入 昵称/电话/渠道名"></el-input>

          <el-button @click="$refs['table-template'].search()" type="primary">搜索</el-button>
        </el-row>

        <el-row>
          <el-tag type="success">成功提现：{{successMoney}}元</el-tag>
          <el-tag type="info">待提现：{{waittingMoney}}元</el-tag>
          <el-tag type="warning">提现失败：{{failMoney}}元</el-tag>
        </el-row>
      </template>

      <template slot="item">
        <el-table-column label="申请时间" width="180">
          <template scope="scope">
            {{scope.row.createTime | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="用户名称" width="180">
          <template scope="scope">
            {{scope.row.nickname }} - {{scope.row.phone}}
          </template>
        </el-table-column>
        <el-table-column prop="channelName" label="来源渠道">
        </el-table-column>

        <el-table-column prop="coinTotalCount" label="累计获得车展币">
        </el-table-column>

        <el-table-column prop="carShowCoinCount" label="累计成功提现">
          <template scope="scope">
            {{scope.row.convertMoney?scope.row.convertMoney:0}}  元
          </template>
        </el-table-column>
        <el-table-column prop="money" label="提现金额">
          <template scope="scope">
            {{scope.row.money}} 元 提现币：{{scope.row.carShowCoinCount}}
          </template>
        </el-table-column>
        <el-table-column label="审核-提现状态">
          <template scope="scope">
            {{scope.row.status | auditStatusFilter}} - {{scope.row.payStatus | payStatusFilter}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
            <template scope="scope">
                <div v-if="scope.row.status==1">
                    <el-button type="text"
                        v-confirm
                        confirm-text="提现审核通过后不能逆转，请二次确认！"
                        :confirm-data="scope.row"
                        @onConfirm="agree">通过</el-button>
                    <el-button type="text"
                      v-confirm
                      confirm-text="提现审核不通过后不能逆转，请二次确认！"
                      :confirm-data="scope.row"
                      @onConfirm="disagree">不通过</el-button>
                </div>
                <div v-else>
                    {{scope.row.auditPersonName}} {{scope.row.auditTime | dateTimeFormat}}
                </div>
            </template>
        </el-table-column>
      </template>
    </table-template>
</el-card>

</template>

<script>
import channelSelect from '@/components/channelSelect'
import TableTemplate from '@/components/TableTemplate'
import CarExhibitionModel from '@/framework/models/CarExhibitionModel'
import BasicPager from '@/mixins/BasicPager'
export default {
  name: 'car-exhibition-withdraw-cash-manager',
  extends: BasicPager,
  components: {
    TableTemplate,
    channelSelect
  },
  data: function () {
    return {
      successMoney: 0,
      failMoney: 0,
      waittingMoney: 0,
      queryParams: {
        channelId: null
      }
    }
  },
  created: function () {
    this.selectWithdrawMoneyReport()
  },
  filters: {
    auditStatusFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '待审核'
          break
        case 2:
          str = '审核通过'
          break
        case 3:
          str = '审核不通过'
          break
        case 4:
          str = '暂缓'
          break
        case 5:
          str = '异常'
          break
        default:
      }
      return str
    },
    payStatusFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '提现成功'
          break
        case 2:
          str = '提现失败'
          break
        case 3:
          str = '提现正在处理'
          break
        default:
      }
      return str
    }
  },
  methods: {
    selectWithdrawMoneyReport: function () {
      let _this = this
      let params = {

      }
      let listener = {
        success: function (dataInfo) {
          _this.successMoney = dataInfo.datas.successMoney / 100
          _this.failMoney = dataInfo.datas.failMoney / 100
          _this.waittingMoney = dataInfo.datas.waittingMoney / 100
        }
      }
      CarExhibitionModel.selectWithdrawMoneyReport(_this, params, listener)
    },
    onDateTimeRangeChange: function (dateTimeRange) {
      if (!dateTimeRange) {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
        this.$refs['table-template'].search()
        return
      }

      if (dateTimeRange[0] && dateTimeRange[1]) {
        this.queryParams.startTime = dateTimeRange[0].getTime()
        this.queryParams.endTime = dateTimeRange[1].getTime()
      }

      this.$refs['table-template'].search()
    },
    agree: function (data) {
      let _this = this
      let params = {
        withdrawCashId: data.id,
        auditPersonId: this.loginInfo.employeeId,
        auditPersonName: this.loginInfo.realName
      }
      let listener = {
        success: function (dataInfo) {
          _this.$message.success('处理成功！')
          _this.$refs['table-template'].search()
        }
      }
      CarExhibitionModel.passWithdrawCash(_this, params, listener)
    },
    disagree: function (data) {
      let _this = this
      let params = {
        withdrawCashId: data.id,
        auditPersonId: this.loginInfo.employeeId,
        auditPersonName: this.loginInfo.realName
      }
      let listener = {
        success: function (dataInfo) {
          _this.$message.success('处理成功！')
          _this.$refs['table-template'].search()
        }
      }
      CarExhibitionModel.notPassWithdrawCash(_this, params, listener)
    }
  }
}

</script>
